<app-base-dialog [topBarTemplate]="topBar" [bottomBarRightTemplate]="bottomBar">
	<ng-template #topBar>
		<app-dialog-header title="Workflow starten"></app-dialog-header>
	</ng-template>

	<div class="dialog-content">
		<div class="form-group">
			<span>Verwerking type</span>
			<app-single-select-dropdown
				[opties]="bulkOptions"
				[selectedOptie]="selectedBulkOption()"
				(onOptieClicked)="bulk.set($event)"
				placeholder="Selecteer verwerking type"
			>
			</app-single-select-dropdown>
		</div>

		<div class="form-group">
			<label for="parallelism">Max. gelijktijdige pods</label>
			<input
				id="parallelism"
				type="number"
				min="1"
				[ngModel]="parallelism()"
				(ngModelChange)="parallelism.set($event)"
				[ngModelOptions]="{ standalone: true }"
				class="number-input"
			/>
		</div>

		<div class="info-section">
			<p><strong>Aantal geselecteerde scholen:</strong> {{ aantalScholen() }}</p>
		</div>
	</div>

	<ng-template #bottomBar>
		<app-button (clickit)="close()" buttonType="secondary">Annuleren</app-button>
		<app-button [enabled]="enabled()" (clickit)="start()">Starten</app-button>
	</ng-template>
</app-base-dialog>

<ng-template #confirmInstellingBulkEnDelta>
	<app-confirm-dialog caption="Bulkverwerking staat aan">
		De bulkverwerking staat aan voor een aantal scholen. Dit betekent dat deze scholen enkele uren geen data zullen zien. Weet je zeker dat je
		wilt doorgaan?
	</app-confirm-dialog>
</ng-template>
